import { Component } from 'js-component-framework';

/**
 * Component for instantiating LoadMore.
 */
export default class LoadMore extends Component {

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Listen for button click
    if (this.children.buttonAnchor) {
      this.children.buttonAnchor
        .addEventListener('click', this.loadMoreClicked.bind(this));
    }
  }

  loadMoreClicked(event) {
    event.preventDefault();

    // Remove load more button
    this.children.button.style.display = 'none';

    // Get the new page
    jQuery.get(this.children.buttonAnchor.href).done((response) => {
      // Create a dom element out of the response
      const responseDiv = document.createElement('div');
      responseDiv.innerHTML = response;

      // Get card dom elements
      const cards = responseDiv.querySelectorAll('.article-card');
      const newUrl = responseDiv
        .querySelectorAll('.article-card-list__cta a');

      // Loop through cards and insert them
      for (let i = 0; i < cards.length; i += 1) {
        this.element.insertBefore(cards.item(i), this.children.button);
      }

      // Update URL and show button again
      if (1 === newUrl.length) {
        this.children.buttonAnchor.href = newUrl[0].href;
        this.children.button.style.display = '';
      }
    });
  }
}



// WEBPACK FOOTER //
// ./client/js/components/LoadMore/LoadMore.js